import React from "react";
import { Button } from "@/uiComponents/components/ui/button";
import { IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

interface AddExpenseButtonProps {
  navigateTo?: string;
  onClick?: () => void;
}

export const AddExpenseButton: React.FC<AddExpenseButtonProps> = ({
  navigateTo = "/addExpense",
  onClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(navigateTo);
    }
  };

  return (
    <div className="fixed bottom-10 right-[3vw] z-10">
      <Button
        onClick={handleClick}
        className="group bg-[#191F29] text-white p-3 cursor-pointer rounded-full hover:bg-[#191F29] transition"
      >
        <div className="flex items-center overflow-hidden">
          <div className="relative flex items-center transition-all duration-300 ease-in-out w-3 group-hover:w-[7.5rem]">
            <IconPlus
              className="absolute left-1/2 -translate-x-1/2 group-hover:static group-hover:translate-x-0 shrink-0"
            />
            <span className="whitespace-nowrap pl-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              Add Expense
            </span>
          </div>
        </div>
      </Button>
    </div>
  );
};
